import React, { useState, useEffect } from 'react';
import { discountTiers } from '../data/mock';

const colorMap = {
  cyan: {
    title: 'text-cyan-400',
    benefit: 'text-cyan-300',
    border: 'border-cyan-500/40',
    shadow: 'shadow-cyan-500/20',
  },
  teal: {
    title: 'text-teal-400',
    benefit: 'text-teal-300',
    border: 'border-teal-500/40',
    shadow: 'shadow-teal-500/20',
  },
  amber: {
    title: 'text-amber-400',
    benefit: 'text-amber-300',
    border: 'border-amber-500/40',
    shadow: 'shadow-amber-600/20',
  },
};

const DiscountOptions = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 py-24 pt-32">
      {/* Header */}
      <div
        className={`text-center mb-12 transition-all duration-700 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-cyan-300 via-teal-400 to-cyan-400 bg-clip-text text-transparent mb-4">
          Discount Options
        </h1>
        <p className="text-xl text-gray-300">
          Save more on your commissions with Twitch subscriptions
        </p>
      </div>

      {/* Tiers */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {discountTiers.map((tier, index) => {
          const colors = colorMap[tier.color];
          return (
            <div
              key={tier.id}
              className={`transition-all duration-700 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${(index + 1) * 150}ms` }}
            >
              <div
                className={`rounded-xl border bg-gradient-to-br ${tier.gradientFrom} ${tier.gradientVia} ${tier.gradientTo} ${colors.border} backdrop-blur-xl shadow-xl ${colors.shadow} h-full transition-all duration-300 hover:scale-105`}
              >
                <div className="p-8 text-center">
                  <h3 className={`text-2xl font-bold ${colors.title} mb-4`}>
                    {tier.title}
                  </h3>
                  <p className="text-gray-300 text-lg mb-2">
                    {tier.description}
                  </p>
                  <p className={`font-semibold ${colors.benefit}`}>
                    {tier.benefit}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DiscountOptions;
